import React, { Component } from "react";
import styled, { css } from "styled-components";
import { connect } from "react-redux";
import api from "api";
import WP from "WP";
import debounce from "lodash.debounce";
import Swiper from "swiper/js/swiper.js";

import Container from "partials/Container";
import GridElement from "partials/GridElement";
import Button from "partials/Button";
import Image from "partials/Image";
import SmartLink from "partials/SmartLink";
import FavoriteButton from "partials/FavoriteButton";

import Arrow from "icons/ArrowIcon";
import Media, { ScreenWidth } from "css/Media";

export class Carousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 0,
    };
    this.swiperRef = React.createRef();
  }

  componentWillMount() {
    this.checkScreenSize();
  }

  componentDidMount() {
    window.addEventListener(
      "resize",
      debounce(() => this.checkScreenSize()),
      500
    );
    this.getHotels();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  }

  checkScreenSize() {
    let isDesktop = false;
    let isMobile = false;

    if (ScreenWidth.lessThan("s")) {
      isMobile = true;
    }
    if (ScreenWidth.greaterThan("m")) {
      isDesktop = true;
    }
    this.setState({
      isDesktop: isDesktop,
      isMobile: isMobile,
    });
  }

  getHotels() {
    api.accommodationFetcher.getAll().then(() => this.filterByRecommended());
  }

  filterByRecommended() {
    const { data, accommodation } = this.props;
    const { recommended_accommodation } = data;

    accommodation.map((hotel) => {
      hotel.recommended = false;
    });

    if (recommended_accommodation && recommended_accommodation.length > 0) {
      recommended_accommodation.map((hotel) => {
        let item = accommodation.find((object) => object.id === hotel.ID);
        if (typeof item !== "undefined") {
          item.recommended = true;
        }
      });
    }

    accommodation.sort(function (a, b) {
      return b.recommended - a.recommended;
    });

    this.initSwiper();
  }

  initSwiper = () => {
    this.swiper = new Swiper(this.swiperRef.current, {
      initialSlide: 0,
      slidesPerView: "auto",
      allowTouchMove: this.state.isMobile ? true : false,
      loop: true,
      loopedSlides: this.props.accommodation.length,
      centeredSlides: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      init: false,
    });
    this.swiper.on("init", () => {
      this.swiper.allowSlidePrev = false;
    });

    this.swiper.on("slideChange", () => {
      this.swiper.allowSlidePrev = this.swiper.realIndex == 0 ? false : true;
      this.swiper.allowSlideNext = this.swiper.realIndex == this.props.accommodation.length - 1 ? false : true;
      this.setState({ active: this.swiper.realIndex });
    });
    this.swiper.init();
  };

  getLowestPrice(hotel) {
    let priceArr = [];
    hotel.room_types.map((room) => {
      priceArr.push(room.from_price);
      return null;
    });
    priceArr.sort();
    return priceArr[0];
  }

  render() {
    const { active, isMobile } = this.state;
    const { data, accommodation } = this.props;

    return accommodation ? (
      <Wrapper>
        <Container grid>
          <GridElement colStart={1} colEnd={13} colSpan>
            <h2>{data.title}</h2>
          </GridElement>
          {!isMobile && (
            <NavGridElement colStart={10} colEnd={22} colSpan align="center" justify="end">
              {accommodation.map((hotel, i) => {
                return (
                  <StyledLi key={hotel.id} isActive={active === i}>
                    {hotel.acf.item_name}
                  </StyledLi>
                );
              })}
            </NavGridElement>
          )}
        </Container>
        {!isMobile && (
          <Container grid>
            <PagGridElement colStart={3} colEnd={8} colSpan>
              <ArrowWrapper back className="swiper-button-prev" disabled={active === 0}>
                <Arrow />
              </ArrowWrapper>
              <ArrowWrapper className="swiper-button-next" disabled={active === accommodation.length - 1}>
                <Arrow />
              </ArrowWrapper>
            </PagGridElement>
          </Container>
        )}
        <Container bleedRight>
          <div className="swiper-container" ref={this.swiperRef}>
            <div className="swiper-wrapper">
              {!isMobile &&
                accommodation.map((hotel) => {
                  return (
                    <StyledDiv className="swiper-slide" key={hotel.id}>
                      <ImageSmartLink to={hotel.link}>
                        <StyledImage image={hotel.acf.featured_image} background ratio="5:4.4" />
                      </ImageSmartLink>
                      <StyledContent>
                        <SmartLink to={hotel.link}>
                          <h3>{hotel.acf.item_name}</h3>
                        </SmartLink>
                        <p>{hotel.acf.description}</p>
                        {this.getLowestPrice(hotel.acf) && (
                          <p>{`${WP.trans.fromNOK}${this.getLowestPrice(hotel.acf)} ${WP.trans.perNight}`}</p>
                        )}
                        <FlexBox>
                          <SmartLink to={hotel.link}>
                            <Button>{WP.trans.seeAvailableRooms}</Button>
                          </SmartLink>
                          <FavoriteButton sort={data.sort} item={hotel} />
                        </FlexBox>
                      </StyledContent>
                    </StyledDiv>
                  );
                })}
              {!isMobile ? <StyledDiv className="swiper-slide"></StyledDiv> : null}
              {isMobile &&
                accommodation.map((hotel) => {
                  return (
                    <div className="swiper-slide" key={hotel.id}>
                      <MobileCard>
                        <SmartLink to={hotel.link}>
                          <StyledImage image={hotel.acf.featured_image} background ratio="5:4.4" />
                        </SmartLink>
                        <StyledContent>
                          <SmartLink to={hotel.link}>
                            <h3>{hotel.acf.item_name}</h3>
                          </SmartLink>
                          <p>{hotel.acf.description}</p>
                          {this.getLowestPrice(hotel.acf) && (
                            <p>{`${WP.trans.fromNOK}${this.getLowestPrice(hotel.acf)} ${WP.trans.perNight}`}</p>
                          )}
                          <ButtonWrapper>
                            <SmartLink to={hotel.link}>
                              <Button>
                                <StyledArrow />
                              </Button>
                            </SmartLink>
                            <FavoriteButton sort={data.sort} item={hotel} />
                          </ButtonWrapper>
                        </StyledContent>
                      </MobileCard>
                    </div>
                  );
                })}
              {isMobile ? <div className="swiper-slide"></div> : null}
            </div>
          </div>
        </Container>
      </Wrapper>
    ) : null;
  }
}

const mapStateToProps = (state) => ({
  accommodation: state.accommodation.posts[WP.lang] ? state.accommodation.posts[WP.lang] : [],
});

const actions = {};

const connectedHotelCarousel = connect(mapStateToProps, actions)(Carousel);
connectedHotelCarousel.displayName = "HotelCarousel";

export default connectedHotelCarousel;

const StyledDiv = styled.div``;

const Wrapper = styled.section`
  user-select: none;
  padding-bottom: ${(props) => props.theme.spacing.elementXL};

  .swiper-container {
    display: flex;
    overflow-x: hidden;
    .swiper-wrapper {
      display: flex;
      align-items: center;
      .swiper-slide {
        display: flex;
        flex-direction: column;
        width: 73.2309231vw;
        color: black;
        z-index: 1000;
        padding-right: 7.077vw;

        a {
          color: ${(props) => props.theme.colors.text};
        }

        ${Media.greaterThan("s")`
                    flex-direction: row;
                    width: calc(100vw - (167px + 8.611vw));
                    padding-right: 0;
                `}

        ${Media.greaterThan("xl")`
                    max-width: 1629.66px;
                `}
      }
    }
    ${Media.greaterThan("s")`
            margin-left: 8.611%;
        `}

    ${Media.greaterThan("xl")`
            margin-left: calc(18 * 8.611px);
        `}
  }

  .container {
    h2 {
      ${(props) => props.theme.fonts.h1};
      margin-bottom: ${(props) => props.theme.spacing.contentXL};

      ${Media.greaterThan("s")`
                margin-bottom: ${(props) => props.theme.spacing.elementM};
            `}
    }
  }

  ${Media.greaterThan("s")`
        padding-bottom: ${(props) => props.theme.spacing.blockXL};
    `}
`;

const NavGridElement = styled(GridElement)`
  ${Media.greaterThan("m")`
        display: flex;
    `}
`;

const StyledLi = styled.li`
  ${(props) => props.theme.fonts.p}
  list-style-type: none;
  color: ${(props) => (props.isActive ? props.theme.colors.text : props.theme.colors.link)};
  margin-right: ${(props) => props.theme.spacing.contentXL};
  white-space: nowrap;

  &:last-of-type {
    margin-right: 0;
  }
`;

const PagGridElement = styled(GridElement)`
  display: flex;
  padding-bottom: ${(props) => props.theme.spacing.elementS};
`;

const MobileCard = styled.div`
  width: 100%;
`;

const ImageSmartLink = styled(SmartLink)`
  width: 100%;
  height: 100%;

  ${Media.greaterThan("s")`
        padding-right: 0;
    `}

  ${Media.greaterThan("s")`
        width: 40.4166666667vw;
    `}
`;

const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;

  &::after {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    content: "";
    background-color: transparent;
    transition: all 0.2s ease-in;
  }

  &:hover {
    &::after {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
`;

const StyledContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  p {
    padding: ${(props) => props.theme.spacing.contentL} 0;

    &:last-of-type {
      padding: 0 0 ${(props) => props.theme.spacing.elementS};
    }
  }

  ${Media.greaterThan("s")`
        width: 50%;
        padding: 0 ${(props) => props.theme.spacing.contentXL};
    `}

  ${Media.greaterThan("m")`
        padding: 0 130px;
    `}

    ${Media.greaterThan("l")`
        padding: 0 ${(props) => props.theme.spacing.blockL};
    `}

    ${Media.greaterThan("xl")`
        padding: 0 190px;
    `}

    ${Media.lessThan("m")`
        p {
            font-size: 14px;
            line-height: 20px;
        }
    `}

    ${Media.lessThan("s")`
        h3 {
            width: 100%;
            padding: 11px 0 0;

            &:hover, &:focus {
                text-decoration: underline;
            }
        }

        p {
            &:last-of-type {
                padding: 0 0 ${(props) => props.theme.spacing.contentM};
            }
        }
    `}
`;

const FlexBox = styled.div`
  display: flex;
  align-items: center;

  > a {
    margin-right: ${(props) => props.theme.spacing.contentXL};
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;

  a {
    width: 26.89618074233459%;
    margin-right: calc((100vw - 50px) / 100 * 7.1);
  }
`;

const StyledArrow = styled(Arrow)`
  fill: ${(props) => props.theme.colors.negative};
`;

const ArrowWrapper = styled.div`
  cursor: pointer;

  svg {
    transition: 0.1s ease;

    ${(props) =>
      props.back &&
      css`
        margin-right: ${(props) => props.theme.spacing.contentL};
        transform: rotate(180deg);
      `}
  }

  ${(props) =>
    props.disabled &&
    css`
      cursor: auto;

      svg {
        fill: ${(props) => props.theme.colors.input};
      }
    `}

  &:hover {
    ${(props) =>
      !props.disabled &&
      css`
        &::after {
          position: absolute;
          content: "";
          bottom: 0;
          left: 0;
          width: 27.453px;
          height: 2px;
          background-color: ${(props) => props.theme.colors.text};
        }
      `}
  }
`;
